// @ts-strict-ignore
import { convertHtmlToReact } from '@hedgedoc/html-to-react';
import styled from 'styled-components';
import { captureException } from '@sentry/nextjs';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { titleMedium } from 'styles-js/mixins/typography';
export default function NHSContent() {
  const {
    attributionLogo,
    attributionUrl,
    content
  } = useSelector(({
    pages
  }) => pages.tag.NHS);
  function transform(node) {
    try {
      if (node?.type === 'tag' && node?.name === 'a') {
        let href = node?.attribs?.href;
        if (node?.attribs?.href?.includes('api.')) {
          href = node.attribs.href.replace('api.', 'www.');
        } else if (node?.attribs?.href?.startsWith('/')) {
          href = `https://www.nhs.uk${node.attribs.href}`;
        }
        node.attribs = {
          ...node?.attribs,
          href,
          target: '_blank',
          rel: 'noreferrer'
        };
      }
    } catch (ex) {
      captureException(ex);
    }
  }
  if (!content) return null;
  return <NHSContainer data-sentry-element="NHSContainer" data-sentry-component="NHSContent" data-sentry-source-file="NHSContent.tsx">
      {convertHtmlToReact(content, {
      transform
    })}

      <a aria-label="NHS website" href={attributionUrl} rel="noreferrer" target="_blank">
        <Logo alt="Content supplied by the NHS website" src={attributionLogo} data-sentry-element="Logo" data-sentry-source-file="NHSContent.tsx" />
      </a>
      <AttributionText data-sentry-element="AttributionText" data-sentry-source-file="NHSContent.tsx">
        {i18n.t('HealthUnlocked contains information from NHS Digital, licensed under the current version of the Open Government Licence')}
      </AttributionText>
    </NHSContainer>;
}
const NHSContainer = styled.div`
  h1, h2, h3, h4, h5, h6 {
    ${titleMedium};
    margin-top: 20px;
  }
  p { // Tag header
    margin-bottom: 10px;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    margin-bottom: 20px;
    li {
      padding-left: 1em;
      text-indent: -.7em;
      ::before {
        content: "• ";
        color: ${props => props.theme.colorGreen};
      }
    }
  }
  .modal-content & {
    p {
      margin-bottom: 20px;
    }
    p:last-of-type {
      margin-bottom: 50px;
    }
  }
`;
const Logo = styled.img`
  margin: 20px 0;
  width: 100%;
`;
const AttributionText = styled.p`
  color: ${({
  theme
}) => theme.colorGreyDark};
`;